import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import * as datasources from "../common_metadata/datasource.js"
import { DrillDown, PlotBand, Tooltip } from "../statistic_components/common_metadata.js"
import { ErrorBoundary } from "../components/error_boundary.js"
import React from "react";
interface DonutChartProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: DonutChartState;
    settings: any;
}


export class DonutChart extends React.Component<DonutChartProps, any>{
    private chartSettingsWrapper: DonutChartState;

    constructor(props: utility.IComponentProps, context: any) {
        super(props, context);
        this.state = { page: 0 };
        this.chartSettingsWrapper = new DonutChartState();
        this.chartSettingsWrapper.hydrateFromJS(props.settings);
    }

    handleDataChanged = (data) => {
        this.setState({ values: data });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.chartSettingsWrapper.hydrateFromJS(nextProps.settings);
    }

    handleSeriesClick = (e) => {
        if (this.props.settings.drilldown && (this.props.settings.drilldown.statisticId) && this.props.settings.drilldown.statisticId != "") {
            var newObj: any = $.extend({}, this.props.queryParameter);
            newObj[this.props.settings.drilldown.destField] = e.dataItem[this.props.settings.drilldown.sourceField];
            newObj._hideInputControls = this.props.settings.drilldown.hideInputControls;
            var params = newObj;
            this.props.context.drillDownObject.requestDrillDown(params, this.props.settings.drilldown.statisticId, e.dataItem);
        }
    }

    render() {
        var settings =
        {
            seriesDefaults: {
                type: "donut",
                startAngle: 150
            },
            legend: { visible: false }
        };


        let plotBands;
        let chartSettings = this.chartSettingsWrapper.chartSettings;
        if (chartSettings) {
            settings = $.extend(settings, chartSettings.toJSON());
        }

        return (
            <react_components.ReactColumn width={this.props.metadataSettings.width}>
                <ErrorBoundary>
                    <react_components.ReactDataPager dataSource={this.chartSettingsWrapper.dataSource} dataSourceId={this.chartSettingsWrapper.dataSource ? this.chartSettingsWrapper.dataSource.getDataSourceIdentifier() : null} uid={this.props.uid} context={this.props.context} titel={this.chartSettingsWrapper.titel} dataUrl={this.props.settings.dataUrl} enablePagging={true} pageSize={Number(this.props.settings.pageSize || 10)} queryParameter={this.props.queryParameter} onVisibleDataChange={this.handleDataChanged}>
                        <react_components.KendoSimpleChart settings={settings} values={this.state.values} height={this.props.settings.height} onSeriesClick={this.handleSeriesClick} />
                    </react_components.ReactDataPager>
                </ErrorBoundary>
            </react_components.ReactColumn>
        );
    }
};

export class DonutChartState extends propertyTypes.BaseComponentProps {
    private heightMetadata = new propertyTypes.TextProperty("height", "Height");
    public height: string;

    private titleMetadata = new propertyTypes.TranslatableTextProperty("titel", "Title");
    public titel: string;

    public dataSource: datasources.Datasource;

    private chartSettingsMetadata = new propertyTypes.ObjectPropertyExt("chartSettings", "Chart settings")
        .addStateImplementation("chartSettings", ChartSettings);
    public chartSettings: ChartSettings;

    private drilldownMetadata = new propertyTypes.ObjectPropertyExt("drilldown", "Drilldown")
        .addStateImplementation("drillDown", DrillDown);
    public drilldown: DrillDown;

    private chartMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.chartMetadata = baseMetaData.concat([this.heightMetadata, this.titleMetadata, datasources.dataSourceMetadata, this.chartSettingsMetadata, this.drilldownMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.chartMetadata;
    }
}

class ChartSettings extends propertyTypes.Serializable {
    private themeMetadata = new propertyTypes.SelectProperty("theme", "Theme").addOption("bootstrap", "Bootstrap").addOption("black", "Black").addOption("silver", "Silver");
    public theme: string;

    private seriesMetadata = new propertyTypes.ObjectListPropertyExt("series", "Series").addStateImplementation("defaultSeries", Series);
    public series: Series[];

    private legendMetadata = new propertyTypes.ObjectPropertyExt("legend", "Legend")
        .addStateImplementation("legend", Legend);
    public legend: Legend

    private labelsMetadata = new propertyTypes.ObjectPropertyExt("labels", "Labels")
        .addStateImplementation("labels", SeriesLabels);
    public labels: SeriesLabels;

    private tooltipMetadata = new propertyTypes.ObjectPropertyExt("tooltip", "Tooltip")
        .addStateImplementation("labels", Tooltip);
    public tooltip: Tooltip;


    private chartSettingsMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.chartSettingsMetadata = [this.themeMetadata, this.seriesMetadata, this.legendMetadata, this.tooltipMetadata];
    }
    getMetadata(): propertyTypes.BaseProperty[] {
        return this.chartSettingsMetadata;
    }
}

class Series extends propertyTypes.Serializable {
    private fieldMetadata = new propertyTypes.ColumnProperty("field", "Field", "dataSource");
    public field: string;

    private colorFieldMetadata = new propertyTypes.ColumnProperty("colorField", "Color field", "dataSource");
    public colorField: string;

    private colorMetadata = new propertyTypes.TextProperty("color", "Color");
    public color: string;

    private nameMetadata = new propertyTypes.TranslatableTextProperty("name", "Name");
    public name: string;

    private categoryFieldMetadata = new propertyTypes.ColumnProperty("categoryField", "Category field", "dataSource");
    public categoryField: string;

    private labelsMetadata = new propertyTypes.ObjectPropertyExt("labels", "Labels")
        .addStateImplementation("stack", SeriesLabels);
    public labels: SeriesLabels;

    private explodeFieldMetadata = new propertyTypes.ColumnProperty("explodeField", "Explode field", "dataSource");
    public explodeField: string;

    private seriesMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.seriesMetadata = [this.fieldMetadata, this.colorFieldMetadata, this.colorMetadata, this.nameMetadata, this.categoryFieldMetadata, this.explodeFieldMetadata, this.labelsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.seriesMetadata;
    }
}

class SeriesLabels extends propertyTypes.Serializable {
    private visibleMetadata = new propertyTypes.CheckBoxProperty("visible", "Visible");
    public visible: boolean = true;

    private templateMetadata = new propertyTypes.TemplateProperty("template", "Template");
    public template: string;

    private positionMetadata = new propertyTypes.SelectProperty("position", "Position")
        .addOption("center", "Center")
        .addOption("insideEnd", "Inside end")
        .addOption("outsideEnd", "Outside end");
    public position: string;

    private labelsMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.labelsMetadata = [this.visibleMetadata, this.templateMetadata, this.positionMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.labelsMetadata;
    }
}

class Legend extends propertyTypes.Serializable {
    private visibleMetadata = new propertyTypes.CheckBoxProperty("visible", "Visible");
    public visible: boolean = true;

    private positionMetadata = new propertyTypes.SelectProperty("position", "Position").addOption("left", "Left").addOption("top", "Top").addOption("right", "Right").addOption("bottom", "Bottom");

    private legendMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.legendMetadata = [this.visibleMetadata, this.positionMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.legendMetadata;
    }
};
